import { Injectable, signal, TemplateRef, inject } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbSlot {
  private readonly router = inject(Router);

  private readonly rightTemplate = signal<TemplateRef<unknown> | null>(null);

  public readonly rightTemplateReadonly = this.rightTemplate.asReadonly();

  constructor() {
    this.router.events
      .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        this.clear();
      });
  }

  public setRight(template: TemplateRef<unknown>): void {
    this.rightTemplate.set(template);
  }

  public clear(): void {
    this.rightTemplate.set(null);
  }
}
